module.exports = __webpack_public_path__ + "static/media/flowers.cd67c5fa.jpg";